import React, { useEffect, useState } from 'react';
import { Clock, AlertTriangle, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  // Countdown timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const newSeconds = prev.seconds - 1;
        const newMinutes = newSeconds < 0 ? prev.minutes - 1 : prev.minutes;
        const newHours = newMinutes < 0 ? prev.hours - 1 : prev.hours;
        return {
          hours: newHours < 0 ? 23 : newHours,
          minutes: newMinutes < 0 ? 59 : newMinutes,
          seconds: newSeconds < 0 ? 59 : newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-8 bg-red-50" data-id="element-537">
      <div className="container mx-auto px-4" data-id="element-538">
        <div className="max-w-3xl mx-auto" data-id="element-539">
          <motion.div className="text-center mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-540">
            <motion.div className="flex justify-center mb-6" animate={{
            rotate: [0, 5, 0, -5, 0]
          }} transition={{
            repeat: Infinity,
            duration: 5,
            ease: 'easeInOut'
          }} data-id="element-541">
              <Clock size={48} className="text-red-500" data-id="element-542" />
            </motion.div>
            <h2 className="text-2xl font-bold mb-4 text-red-600" data-id="element-543">
              NO ESPERES MÁS
            </h2>
            <p className="text-xl mb-8" data-id="element-544">
              Cada pastilla que tomas sin necesidad te aleja de tu equilibrio.
              Cada vez que lo postergas, refuerzas la dependencia.
            </p>
          </motion.div>
          <motion.div className="bg-white p-6 rounded-xl shadow-lg mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-545">
            <div className="flex items-center mb-4" data-id="element-546">
              <AlertTriangle size={24} className="text-red-500 mr-3 flex-shrink-0" data-id="element-547" />
              <h3 className="font-bold text-lg" data-id="element-548">La oferta expira pronto</h3>
            </div>
            <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-549">
              <div className="bg-red-100 p-3 rounded-lg text-center" data-id="element-550">
                <motion.div className="text-2xl font-bold text-red-600" animate={{
                scale: [1, 1.1, 1]
              }} transition={{
                repeat: Infinity,
                duration: 1,
                repeatDelay: 1
              }} data-id="element-551">
                  {timeLeft.hours.toString().padStart(2, '0')}
                </motion.div>
                <div className="text-xs font-medium" data-id="element-552">HORAS</div>
              </div>
              <div className="bg-red-100 p-3 rounded-lg text-center" data-id="element-553">
                <motion.div className="text-2xl font-bold text-red-600" animate={{
                scale: [1, 1.1, 1]
              }} transition={{
                repeat: Infinity,
                duration: 1,
                repeatDelay: 1
              }} data-id="element-554">
                  {timeLeft.minutes.toString().padStart(2, '0')}
                </motion.div>
                <div className="text-xs font-medium" data-id="element-555">MINUTOS</div>
              </div>
              <div className="bg-red-100 p-3 rounded-lg text-center" data-id="element-556">
                <motion.div className="text-2xl font-bold text-red-600" animate={{
                scale: [1, 1.1, 1]
              }} transition={{
                repeat: Infinity,
                duration: 1,
                repeatDelay: 1
              }} data-id="element-557">
                  {timeLeft.seconds.toString().padStart(2, '0')}
                </motion.div>
                <div className="text-xs font-medium" data-id="element-558">SEGUNDOS</div>
              </div>
            </div>
            <p className="text-center mb-4" data-id="element-559">
              Antes de que termine este contador, asegura tu{' '}
              <span className="font-bold" data-id="element-560">RelaxGlow al 50% de descuento</span>
            </p>
            <motion.a href="https://shopysv.com/products/pide-tu-gorro-anti-migrana" className="flex items-center justify-center w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-lg transition-colors" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} data-id="element-561">
              <span data-id="element-562">Aprovechar esta oferta ahora</span>
              <motion.div animate={{
              x: [0, 5, 0]
            }} transition={{
              repeat: Infinity,
              duration: 1.5
            }} className="ml-2" data-id="element-563">
                <ArrowRight size={18} data-id="element-564" />
              </motion.div>
            </motion.a>
          </motion.div>
          <motion.p className="text-2xl font-bold text-red-600 text-center" animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} data-id="element-565">
            🔥 El momento de volver a lo natural es ahora.
          </motion.p>
        </div>
      </div>
    </section>;
}